module.exports = __webpack_public_path__ + "assets/img/7760b9e3eea29aaa6c9fb06755b228ea.png";